import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth/authConfig";
import SetTitle from "../SetTitle";
import { assetUrl, radarNameShort  } from "../../config";
import "./login-page.scss";

export default function LoginPage() {
  const { instance } = useMsal();
  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.log(e);
    });
  };
  return (
    <section className="login-page">
      <SetTitle title={radarNameShort} /> 
      <div className="login-page__container">
        <img
        className="logo-link__img"
        src={assetUrl("logo.svg")}
        width="300px"
        height="60px"
        alt="xDesign"
        />
        <p className="login-page__text">Welcome to the xDesign Tech Radar.</p>
        <button className="login-page__button" onClick={() => handleLogin()}>Login to continue ➝ </button>
      </div>
    </section>
  );
}
